import {useNavigate} from 'react-router-dom';
import useGetBasketCount from '../../services/hookService/getBasketCount/useGetBasket';
import SpinnerLoading from '../SpinnerLoading';

const HeaderBasketButton = () => {
  const {data: totalBasketQuantity, isLoading} = useGetBasketCount();
  const navigate = useNavigate();

  return (
    <div
      className="relative flex gap-2"
      onClick={() => navigate('/shopping-basket')}
    >
      {isLoading ? (
        <SpinnerLoading size={12} />
      ) : (
        <>
          <i className="icon-nameBuy text-[25px] text-gray-700 relative" />
          {Boolean(totalBasketQuantity) && (
            <div className="flex items-center justify-center size-4 absolute text-white text-sm rounded-full bg-red-600 -right-3 -top-2">
              {totalBasketQuantity}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default HeaderBasketButton;
